import axios from "axios";
import { IAPIPayload } from "../../../interfaces/apiInterface";
import { GET_IPD_DASHBOARD_DATA } from "../../../config/config";

export const getAllIpdDashboardCase = (data: IAPIPayload) => {
  return axios.post(GET_IPD_DASHBOARD_DATA, data);
};
